import React, { Component } from "react";
// import Textarea from "react-textarea-autosize";

// Components
import SaveBtn from "../../utils/edit-item/SaveBtn";
import DeleteBtn from "../../utils/edit-item/DeleteBtn";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";
import CKEditorInput from "../../../utils/forms/CKEditorInput";

// Utils
import { handleKeyPress } from "../../../utils/forms/inputHandling";

// CSS
import "../../../css/forms/edit-item.css";

class FaqItemAdmin extends Component {
	constructor(props) {
		super(props);
		this.CKEditorInput = new CKEditorInput();
	}

	render() {
		const { item, updateLoading } = this.props;

		return (
			<div
				className={
					"edit-item edit-item--rows" + (item.successfull ? ` successful-row` : ``)
				}
			>
				<div className="item-row">
					<input
						type="text"
						id="question"
						className="main-field"
						placeholder="Enter question"
						maxLength="255"
						disabled={updateLoading}
						value={item.question}
						onKeyPress={e => handleKeyPress(e, this.props.handleSubmit)}
						onChange={this.props.handleInputChange}
					/>
					<div className="btn-wrap">
						<SaveBtn
							shown={!!item.titleChanged}
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.handleSubmit}
						/>
						<DeleteBtn
							loading={!!item.saving}
							disabled={!!item.saving}
							onClick={this.props.deleteItem}
						/>
					</div>
				</div>
				<div className="item-row">
					<div className="item-row--full-flex">
						<CKEditor
							scriptUrl="/ckeditor/ckeditor.js"
							content={item.answer}
							config={{
								filebrowserBrowseUrl: "/file-browser",
								uploadUrl: process.env.REACT_APP_API_URL + `files`
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: e => this.props.editorChange(e, "answer")
							}}
							ref={instance => {
								this.CKEditorInput.addEditor("answer", instance);
							}}
						/>
					</div>
					<div className="">
						<div
							className={`custom-label checkbox-label${
								updateLoading ? " disabled-label" : ""
							}`}
						>
							<input
								type="checkbox"
								id={`restricted-${item.id}`}
								name="restricted"
								value="1"
								checked={!!item.restricted ? item.restricted : false}
								disabled={updateLoading}
								onChange={this.props.handleCheckboxClick}
							/>
							<label htmlFor={`restricted-${item.id}`}>Restricted</label>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default FaqItemAdmin;



// WEBPACK FOOTER //
// ./src/components/admin/faq/FaqItemAdmin.js